import { render, staticRenderFns } from "./BankInfo2.vue?vue&type=template&id=2aae6fef&scoped=true"
import script from "./BankInfo2.vue?vue&type=script&lang=js"
export * from "./BankInfo2.vue?vue&type=script&lang=js"
import style0 from "./BankInfo2.vue?vue&type=style&index=0&id=2aae6fef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aae6fef",
  null
  
)

export default component.exports